import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { MdSnackBar, MdSnackBarConfig, MdDialog, MdDialogRef } from '@angular/material';
import { Title } from '@angular/platform-browser';
import { FormBuilder, Validators } from "@angular/forms";
import { UserService } from '../common/user.service';

import { CountryService } from '../common/country.service';
import { ActivityService } from '../common/activity.service'
import { PackageService } from '../common/package.service';
import { CreditService } from '../common/credit.service';

@Component({
  selector: 'app-edit-travel',
  templateUrl: './edit-travel.component.html',
  styleUrls: ['./edit-travel.component.css'],
  providers: [UserService, CountryService, ActivityService, PackageService, CreditService]
})
export class EditTravelComponent implements OnInit {

  errorMessage: any;
  Info: any;
  infoArray: any;
  eventUserId: any;
  travelInfo: any;
  userInfo = JSON.parse(localStorage.userInfo);
  spinner: boolean = false;
  balance = 0;
  payType = '';
  price: number = 0;
  public eventId: any;
  creditCard: any = {
    cardId: 0,
    name: '',
    cardType: 'visa',
    number: '',
    expMonth: '',
    expYear: '',
    cvv: '',
    type: undefined,
    save: false,
    existing: true,
    address1: '',
    address2: '',
    city: '',
    stateId: '',
    state: '',
    countryId: '',
    country: '',
    zip: ''
  };

  billingAddress = {
    name: '',
    line1: '',
    line2: '',
    city: '',
    stateId: '',
    state: '',
    countryId: '',
    country: '',
    zipcode: '',
    sameAsUser: true
  }

  countries = [];
  states = [];
  cards = [];
  billingStates: any;
  userId: any;
  userType: any;
  cardUse = 'old';
  transType: any;

  type: any;
  public users = [];
  public activities: any;
  public packageId: any;
  public freeActivities = [];

  cardFrom: any = 'old';



  constructor(private pageTitle: Title, private router: Router, public dialogRef: MdDialogRef<EditTravelComponent>, private formBuilder: FormBuilder, private UserService: UserService, private snackBar: MdSnackBar, private creditService: CreditService, private countryService: CountryService) { }

  ngOnInit() {

    if (this.eventId && this.userId && this.type) {
      this.getinfoattendee(this.eventId, this.userId);
    } else {
      this.snackBar.open('something went wrong!', '', { duration: 4000 });
      this.dialogRef.close();
    }

    //console.log(this.users);
    console.log(this.Info);
    this.billingSameAsUser();

    this.Info.arriveDateTime = (this.Info.arriveByPlane == 1) ? this.Info.arriveDateTime : '';
    this.Info.returnDateTime = (this.Info.arriveByPlane == 1) ? this.Info.returnDateTime : '';
    this.travelInfo = {
      arriveHour: (this.Info.arriveDateTime) ? this.formatAMPM(this.Info.arriveDateTime, 0) : '',
      arriveMinutes: (this.Info.arriveDateTime) ? this.formatAMPM(this.Info.arriveDateTime, 1) : '',
      arriveAmPm: (this.Info.arriveDateTime) ? this.formatAMPM(this.Info.arriveDateTime, 2) : '',

      returnHour: (this.Info.returnDateTime) ? this.formatAMPM(this.Info.returnDateTime, 0) : '',
      returnMinutes: (this.Info.returnDateTime) ? this.formatAMPM(this.Info.returnDateTime, 1) : '',
      returnAmPm: (this.Info.returnDateTime) ? this.formatAMPM(this.Info.returnDateTime, 2) : '',

      arriveAirportName: (this.Info.arriveAirportName) ? this.Info.arriveAirportName : '',
      returnAirportName: (this.Info.returnAirportName) ? this.Info.returnAirportName : '',

      userId: this.Info.userId,
      eventId: this.Info.eventId,
      eventUserId: this.Info.id,
      arriveByPlane: (this.Info.arriveByPlane) ? this.Info.arriveByPlane : 0,
      arriveFlightName: (this.Info.arriveFlightName) ? this.Info.arriveFlightName : '',
      arriveFlightNumber: (this.Info.arriveFlightNumber) ? this.Info.arriveFlightNumber : '',
      arriveDateTime: this.Info.arriveDateTime,
      arriveDateTime_: (this.Info.arriveDateTime && this.Info.arriveDateTime!='0000-00-00 00:00:00') ? new Date(this.Info.arriveDateTime) : '',
      arriveNames: (this.Info.arriveNames) ? this.Info.arriveNames : '',
      returnFlightName: (this.Info.returnFlightName) ? this.Info.returnFlightName : '',
      returnFlightNumber: (this.Info.returnFlightNumber) ? this.Info.returnFlightNumber : '',
      returnDateTime: this.Info.returnDateTime,
      returnDateTime_: (this.Info.returnDateTime && this.Info.returnDateTime!='0000-00-00 00:00:00') ? new Date(this.Info.returnDateTime) : '',
      returnNames: (this.Info.returnNames) ? this.Info.returnNames : '',
      busChargeAmount_: this.Info.busChargeAmount_ ? this.Info.busChargeAmount_ : '0.00',
      busChargeTransId_: this.Info.busChargeTransId_,
    };

    this.countryService.getCountries().subscribe(response => {
      this.countries = response;
      for (var i = 0; i < this.countries.length; i++)
        if (this.countries[i].name == 'USA') {
          this.billingAddress.countryId = this.countries[i].id;
          this.billingCountryChanged();
        }
    });

    console.log(this.travelInfo.busChargeAmount_);
  }

  formatAMPM(dt, n) {

    //var hours = date.getHours();
    //var minutes = date.getMinutes();
    //console.log(minutes);
    //var ampm = hours >= 12 ? 'Pm' : 'Am';
    //hours = hours % 12;
    //hours = hours ? hours : 12; // the hour '0' should be '12'
    ////  minutes = minutes < 5 ? '00' : minutes;
    //console.log('mm' + minutes);
    //if (n == 0) {
    //  return hours;
    //}
    //if (n == 1) {
    //
    //  return minutes
    //}
    //if (n == 2) {
    //  return ampm
    //}

    if (dt) {
      if (typeof dt == 'string') {
        dt = dt.split(' ');
        dt = dt[1].split(':');
        var ampm = dt[0] >= 12 ? 'Pm' : 'Am';

        var hours = (dt[0]>0)?( (dt[0]==12) ? dt[0] : dt[0] % 12 ):((dt[0]==0)?12:0);
        if(hours==12){
          hours = hours % 12;
          hours = hours ? hours : 12;
        }
        var minutes = dt[1];
        minutes = minutes < 10 ? ('00' + (minutes)).slice(-2) : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        if (n == 0) {
          return hours;
        }
        if (n == 1) {
          if (!isNaN(minutes) && minutes > 0)
            minutes = minutes < 10 ? ('00' + (minutes)).slice(-2) : minutes;
          else
            minutes = '00';
          return minutes
        }
        if (n == 2) {
          return ampm
        }
      }else{
        return '';
      }
    }
  }



  dateTimeFormat(dt) {
    if (dt) {
      var m = dt.getMonth() + 1;
      if (m < 10)
        m = '0' + m;
      var d = dt.getDate();
      if (d < 10)
        d = '0' + d;
      return dt.getFullYear() + '-' + m + '-' + d + ' 00:00:00';
    }
    else
      return '';
  }

  editAtt(info) {
    this.travelInfo.arriveDateTime = (this.travelInfo.arriveDateTime_!='')?this.dateTimeFormat(this.travelInfo.arriveDateTime_):'';
    this.travelInfo.returnDateTime = (this.travelInfo.returnDateTime_!='')?this.dateTimeFormat(this.travelInfo.returnDateTime_):'';

    if (info.valid) {
      this.price = ((this.travelInfo.busChargePersons == 1) && this.travelInfo.busChargeAmount_ && this.travelInfo.busChargeAmount_ <= '0.00') ? 50 : 0;
      this.spinner = true;
      this.cardType();
      this.UserService.saveTravelInfo({ travelInfo: this.travelInfo, type: this.userInfo.type, creditCard: this.creditCard, payType: this.payType, cardFrom: this.cardFrom, mainUser: this.users[0].eventUser.userId, parentEventUserId: this.users[0].eventUser.id, eventId: this.Info.eventId, price: this.price }).subscribe(
        response => {
          this.spinner = false;
          if (response.status) {
            this.snackBar.open('Travel info updated successfully', '', { duration: 4000 });
            this.dialogRef.close(response.status);
          }
          else {
            this.snackBar.open(response.msg, '', { duration: 4000 });
            this.spinner = false;
          }
        },
        error => {
          this.spinner = false;
        }
      );

    }
  }

  close() {
    this.dialogRef.close();
  }

  triggerClick(id) {
    (<HTMLInputElement>window.document.getElementById(id)).click()
  }

  cardType() {
    this.creditCard.cardType = this.creditService.parseCardType(this.creditCard.number);
  }

  billingSameAsUser() {
    this.spinner = true;
    if (this.billingAddress.sameAsUser) {
      this.billingAddress.name = this.users[0].eventUser.companyName;
      this.billingAddress.line1 = this.users[0].eventUser.addressLine1;
      this.billingAddress.line2 = this.users[0].eventUser.addressLine2;
      this.billingAddress.city = this.users[0].eventUser.city;
      this.billingAddress.stateId = this.users[0].eventUser.stateId;
      this.billingAddress.state = this.users[0].eventUser.stateName;
      this.billingAddress.countryId = this.users[0].eventUser.countryId;


      this.creditCard.address1 = this.users[0].eventUser.addressLine1;
      this.creditCard.address2 = this.users[0].eventUser.addressLine2;
      this.creditCard.city = this.users[0].eventUser.city;
      this.creditCard.stateId = this.users[0].eventUser.stateId;
      this.creditCard.state = this.users[0].eventUser.stateName;
      this.creditCard.countryId = this.users[0].eventUser.countryId;


      this.countryService.getStates(this.users[0].eventUser.countryId).subscribe(
        response => {
          this.spinner = false;
          this.billingStates = response;
        },
        error => {
          this.spinner = false;
        }
      );
      this.creditCard.country = this.users[0].eventUser.countryName;
      this.creditCard.zipcode = this.users[0].eventUser.zipcode;
    }
    else {
      this.spinner = false;
      this.billingAddress.name = '';
      this.billingAddress.line1 = '';
      this.billingAddress.line2 = '';
      this.billingAddress.city = '';
      this.billingAddress.stateId = '';
      this.billingAddress.state = '';
      this.billingAddress.countryId = '';
      this.billingAddress.country = '';
      this.billingAddress.zipcode = '';

      this.creditCard.address1 = this.billingAddress.line1;
      this.creditCard.address2 = this.billingAddress.line2;
      this.creditCard.city = this.billingAddress.city;
      this.creditCard.stateId = this.billingAddress.stateId;
      this.creditCard.state = this.billingAddress.state;
      this.creditCard.countryId = this.billingAddress.countryId;
      this.creditCard.country = this.billingAddress.country;
      this.creditCard.zip = this.billingAddress.zipcode;
      this.creditCard.zipcode = this.billingAddress.zipcode;

    }
  }

  billingStateChanged() {
    for (var i = 0; i < this.billingStates.length; i++)
      if (this.billingStates[i].id == this.creditCard.stateId)
        this.creditCard.state = this.billingStates[i].name;
  }



  billingCountryChanged() {
    this.spinner = true;
    this.countryService.getStates(this.creditCard.countryId).subscribe(
      response => {
        this.spinner = false;
        this.billingStates = response;
      },
      error => {
        this.spinner = false;
        this.snackBar.open(error, '', { duration: 4000 });
      }
    );
    for (var i = 0; i < this.countries.length; i++)
      if (this.countries[i].id == this.creditCard.countryId)
        this.creditCard.country = this.countries[i].name;
  }

  validateDigit(num, min, max) {
    return num.match("^[0-9]{" + min + "," + max + "}$");
  }

  validateZip(zip, country) {
    return true;
    // if (country == 'Canada')
    //   var re = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/;
    // else
    //   var re = /^\d{5}(-\d{4})?$/;
    // return re.test(zip);
  }

  getinfoattendee(eventId, userId) {

    this.spinner = true;

    this.UserService.getInfoAttendee({ eventId: eventId, userId: userId, eventUserId: this.eventUserId }).subscribe(
      response => {
        this.spinner = false;
        this.infoArray = response;
        this.cards = this.infoArray.creditCard;
        if (this.cards && this.cards.length > 0) {
          this.creditCard.existing = true;
        }
        else {
          this.creditCard.existing = false;
        }
        this.cardUse = (this.infoArray.creditCard.length > 0) ? 'old' : 'new';
        //this.transType = this.infoArray.packageInfo[0].transType;
      },
      error => {
        this.spinner = false;
        this.errorMessage = <any>error;
      }
    );
    console.log(this.creditCard.existing);
  }

  oldCard(id) {
    if (id) {
      this.creditCard.cardId = id;
    } else {
      this.creditCard.cardId = 0;
    }
  }

  cardFroms(type) {
    if (type) {
      this.cardFrom = type;
      if (type == 'new') {
        this.creditCard.cardId = '';
      }
    }
  }




}



// WEBPACK FOOTER //
// /var/www/html/nissco_event_web/angular/src/app/edit-travel/edit-travel.component.ts